module.exports = __webpack_public_path__ + "img/heart-multiple-outline.95dc130f.svg";